import { ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { AggregationType, AggregationTypes } from '@carto/api-client'
import { CategoryWidget, MapDatasetEnriched } from 'features/builder'
import { KeplerFieldType } from 'features/builder/types'
import { DefaultOperationEntries, isCustomAggregationExpSupported } from './utils'

export const availableFieldTypesForColumn: KeplerFieldType[] = [ALL_FIELD_TYPES.string, ALL_FIELD_TYPES.boolean]
export const availableFieldTypesForOperationColumn: KeplerFieldType[] = [ALL_FIELD_TYPES.integer, ALL_FIELD_TYPES.real]

export function isCategoryWidgetValid(widget: CategoryWidget, { source }: { source: MapDatasetEnriched }): boolean {
  const columnType = source.fields.find((f) => f.id === widget.column)?.type
  const columnValid = Boolean(columnType) && availableFieldTypesForColumn.includes(columnType as KeplerFieldType)

  if (widget.operation === AggregationTypes.Custom) {
    return columnValid && isCustomAggregationExpSupported({ source }) && Boolean(widget.operationExp)
  }

  if (widget.operation === AggregationTypes.Count) {
    return columnValid
  }

  const operationColumnType = source.fields?.find((f) => f.id === widget.operationColumn)?.type as KeplerFieldType
  const operationColumnValid =
    operationColumnType && availableFieldTypesForOperationColumn.includes(operationColumnType)

  return Boolean(columnValid && operationColumnValid)
}

export function validateCategoryWidget(
  widget: CategoryWidget,
  { source }: { source: MapDatasetEnriched }
): CategoryWidget {
  const columnType = source.fields.find((f) => f.id === widget.column)?.type
  const columnValid = columnType && availableFieldTypesForColumn.includes(columnType)

  if (!columnValid) {
    widget.column = ''
  }

  const availableOperations = categoryWidgetAvailableOperations(source)
  if (!widget.operation || !availableOperations.includes(widget.operation)) {
    widget.operation = AggregationTypes.Count
  }

  if (widget.operation === AggregationTypes.Count) {
    widget.operationColumn = ''
    widget.isValid = Boolean(columnValid)
  } else if (widget.operation === AggregationTypes.Custom) {
    if (!isCustomAggregationExpSupported({ source })) {
      widget.operation = AggregationTypes.Count
      widget.isValid = Boolean(columnValid)
    } else {
      widget.operationColumn = ''
      widget.isValid = Boolean(columnValid && widget.operationExp)
    }
  } else {
    const operationColumnType = source.fields.find((f) => f.id === widget.operationColumn)?.type
    const operationColumnValid =
      operationColumnType && availableFieldTypesForOperationColumn.includes(operationColumnType)
    if (!operationColumnValid) {
      widget.operationColumn = ''
    }
    widget.isValid = Boolean(columnValid && operationColumnValid)
  }

  return widget
}

export function categoryWidgetAvailableOperations(source: MapDatasetEnriched): AggregationType[] {
  const supportsCustomAggregation = isCustomAggregationExpSupported({ source })
  const supportsNormalAggregation = source.fields.some((f) => availableFieldTypesForOperationColumn.includes(f.type))

  const result: AggregationType[] = []
  if (!supportsNormalAggregation) {
    result.push(AggregationTypes.Count)
  } else {
    result.push(...DefaultOperationEntries)
  }
  if (supportsCustomAggregation) {
    result.push(AggregationTypes.Custom)
  }
  return result
}

export function isWidgetCategoryAvailable(source: MapDatasetEnriched): boolean {
  return source.fields.some((f) => availableFieldTypesForColumn.includes(f.type))
}
